(function($) {
    'use strict';

    $('.postcode-checker').on('submit', 'form', function(e) {
        var zipCodeRegex = /^[1-9][0-9]{3} ?[a-z]{0,2}$/i;
        var $zipCode = $(e.delegateTarget).find('[name="zipCode"]');
        var $errorMessage = $zipCode.next('.error-message');
        var data = {
            zipCode: $zipCode.val()
        };

        e.preventDefault();

        // Friendly handle mistakes
        if ( ! zipCodeRegex.test($zipCode.val()) ) {
            $zipCode.one('keypress', function() {
                $errorMessage.hide();
            })
            $zipCode.focus().select();
            $errorMessage.show();
            return;
        }

        $('#postcode-modal').data('ajax-data', data).modal('show');
    });

})(jQuery);